import apiClient, { withAuth } from './api';

export const paymentService = {
  // Invoices
  getInvoices: (token) => {
    return apiClient.get('/api/invoices/', withAuth(token));
  },
  
  downloadInvoice: (invoiceId, token) => {
    return apiClient.get(`/api/download-invoice/${invoiceId}/`, withAuth(token));
  },
  
  // Payment Methods
  getPaymentMethods: (token) => {
    return apiClient.get('/api/payment-methods/', withAuth(token));
  },
  
  addPaymentMethod: (data, token) => {
    return apiClient.post('/api/add-payment-method/', data, withAuth(token));
  },
  
  updatePaymentMethod: (data, token) => {
    return apiClient.post('/api/update-payment-method/', data, withAuth(token));
  },
  
  deletePaymentMethod: (methodId, token) => {
    return apiClient.post('/api/delete-payment-method/', { payment_method_id: methodId }, withAuth(token));
  },
  
  setDefaultPaymentMethod: (methodId, token) => {
    return apiClient.post('/api/set-default-payment-method/', { payment_method_id: methodId }, withAuth(token));
  },
  
  // Subscriptions
  getSubscriptions: (token) => {
    return apiClient.get('/api/subscriptions/', withAuth(token));
  },
  
  getSubscriptionStatus: (subscriptionId, token) => {
    return apiClient.get(`/api/payments/subscription/status/${subscriptionId}/`, withAuth(token));
  },
  
  cancelSubscription: (data, token) => {
    return apiClient.post('/api/cancel-subscription/', data, withAuth(token));
  },
  
  // Payments & Checkout
  createPaymentIntent: (data, token) => {
    return apiClient.post('/api/payments/create-payment-intent/', data, withAuth(token));
  },
  
  verifyPayment: (paymentIntentId, token) => {
    return apiClient.get(`/api/payments/verify/${paymentIntentId}/`, withAuth(token));
  },
  
  createTransferPayment: (data, token) => {
    return apiClient.post('/api/payments/create-transfer-payment/', data, withAuth(token));
  },
  
  // Payment Overview
  getPaymentOverview: (token) => {
    return apiClient.get('/api/payment-overview/', withAuth(token));
  },
  
  getSpendingData: (token) => {
    return apiClient.get('/api/spending-data/', withAuth(token));
  },
  
  // Identity Verification
  createIdentityVerification: (data, token) => {
    return apiClient.post('/api/identity/verification', data, withAuth(token));
  },
  
  getStripeVerificationStatus: (token) => {
    return apiClient.get('/api/user/stripe-verification-status', withAuth(token));
  },
  
  // Debug and Testing endpoints
  debugStripeVerification: (token) => {
    return apiClient.get('/api/debug/stripe-verification', withAuth(token));
  },
  
  forceStripeVerification: (token) => {
    return apiClient.get('/api/testing/force-verification', withAuth(token));
  }
};

export default paymentService;